export const CONFIG_ITEMS = [
    'timeoutConfigurationItems',
    'realityCheckConfigurationItems',
    'sessionTimerConfigurationItems',
    'betLimitConfigurationItems',
    'loginLimitsConfigurationItems',
    'lossLimitConfigurationItems',
    'productLimitConfigurationItems',
    'depositLimitConfigurationItems'
];

export const LIMITS_WITHOUT_TYPES = {
    realityCheckConfigurationItems: 1,
    sessionTimerConfigurationItems: 2
};

export const ALL_LIMIT_TYPES = [
    'timeout',
    'realityCheck',
    'sessionTimer',
    'lossLimits',
    'betLimits',
    'loginLimits',
    'productBet',
    'productLoss',
    'depositLimits'
];

export const PORTLET_TYPES_TO_APP_TYPES_MAP = {
    responsiblegamingbetlimits: 'betLimits',
    responsiblegaminglosslimits: 'lossLimits',
    responsiblegamingloginlimits: 'loginLimits',
    responsiblegamingdepositlimits: 'depositLimits',
    'product-loss-limit': 'productLoss',
    'product-bet-limit': 'productBet'
};
